import { useEffect, useState } from 'react';
import DocumentMeta from 'react-document-meta';

import config from '../config';

const meta = {
  title: 'What We Stand For | Free medication abortion',
  description: '',
  meta: {
    charset: 'utf-8',
    name: {
      keywords: '',
    },
    property: {
      'og:title': 'What We Stand For | Free medication abortion',
      'og:description': '',
      'og:image': '',
    },
  },
};

export default function Epitome() {
  const [cmsData, setCmsData] = useState(undefined);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${config.contentBaseUrl}/content/item/wwsf`,
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        if (result._id) {
          console.log(result);
          setCmsData(result);
        }
      } catch (error) {
        console.log(error.message);
      } finally {
        //
      }
    };

    fetchData();
  }, []);

  if (!cmsData) {
    return null;
  }

  return (
    <DocumentMeta {...meta}>
      <div className="epitome-page">
        <div className="page-title dark-background text-start contact-bg">
          <div className="container position-relative">
            <h1>{cmsData.title || ''}</h1>
          </div>
        </div>

        <section className="section light-background py-4">
          <div className="text-center">
            <h3>{cmsData.subtitle || ''}</h3>
          </div>
        </section>

        <section className="epitome section light-background py-4 border-bottom">
          <div className="container section-title pb-0">
            <div
              className="col-lg-12 content cms-content"
              dangerouslySetInnerHTML={{ __html: cmsData.content || '' }}
            ></div>
          </div>
        </section>
      </div>
    </DocumentMeta>
  );
}
